// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"123":"6cd35798","636":"84ca4d22"}[chunkId] + ".chunk.js";
};